export const STATUS_TYPES = {
  ACTIVE: "Active",
  DEACTIVE: "Deactive",
}

export const USER_COLUMNS = [
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "mobile", label: "Mobile" },
  { key: "role", label: "Role" },
  { key: "status", label: "Status" },
];

export const USER_FORM_LABELS = {
  role: "Role",
  is_approved: "Approval Status",
};

export const USER_COLUMN_WIDTHS = {
  name: "w-40",
  email: "w-52",
  mobile: "w-36",
  role: "w-32",
  status: "w-24",
  actions: "w-16",
  checkbox: "w-8",
};
